import * as Sentry from "@sentry/react";

// For a promise that nothing waits for: an unexpected rejection reaches Sentry as a handled exception
// instead of being left unhandled. It keeps the call sites free of `void`, which complexity/noVoid
// forbids, and of the biome-ignore pragma each `void` would need.
export const fireAndForget = (promise: Promise<unknown>): void => {
	promise.catch((error: unknown) => Sentry.captureException(error));
};
